











import { Component, Prop, Vue } from 'vue-property-decorator';
import TextInput from './_text.input.vue';
@Component({
  components: {
    'text-input': TextInput
  },
})
export default class InputEps extends Vue {

  @Prop()
  placeholder!: string;

  public label = 'EPS';
  public error = '';
  public icon = 'medical_services'

  onChange($text) {
    console.error($text)
      if($text.length === 0){
          this.error = 'EPS invalida';
      } else {
        this.$emit('nChange', $text)
          this.error = '';
      }
  }

}
